import m from "mithril";
const Link = m.route.Link;
export default {
    view() {
        return (m("article", null,
            m("div", { class: "alert alert--success alert--icon" },
                m("i", { class: "fas fa-check" }),
                m("span", null, "Du bist eingeloggt.")),
            m("p", null, "Herzlichen Gl\u00FCckwunsch. Obwohl du dein Passwort vergessen hast, bist du angemeldet."),
            m("p", null, "Nun tue etwas n\u00FCtzliches. Viel Spa\u00DF!"),
            m("div", { class: "tr" },
                m(Link, { class: "btn btn--link", href: "/hub" },
                    "Weiter ",
                    m("i", { class: "fas fa-arrow-right ml1" })))));
    },
};
